import { useMemo, useState } from 'react'
import AtivoPatrimonialHttp from '../../../../services/api/https/patrimonio/ativo-patrimonial.http'
import PatrimonioOwnerHttp from '../../../../services/api/https/patrimonio/patrimonio-owner.http'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL_FECTH: 'Carregando os Ativos',
  FETCH_ATIVOS: 'Adquirindo Ativos Desse Dono',
}

export const ATIVO_MODAL_NAME = {
  NONE: 'NONE',
  CADASTRO: 'CADASTRO',
  LOCAL_MOVIMENTACAO: 'LOCAL_MOVIMENTACAO',
}
const INITIAL_STATE = {
  owners: [],
  selectedOwner: null,
  errorMessage: null,
  loadingMessage: LOAD_MESSAGE.NONE,
  ativos: [],
  selectedAtivo: null,
  showModal: ATIVO_MODAL_NAME.NONE,
}

export default function useAtivoPatrimonial() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    // Helper
    return {
      // Action
      resetState() {
        setState(prevState => ({
          ...prevState,
          errorMessage: null,
        }))
      },
      getAtivosByOwner(ownerId) {
        AtivoPatrimonialHttp.fetchAtivosByOwner(ownerId)
          .then(ativos =>
            setState(prevState => ({
              ...prevState,
              ativos: ativos,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },
      // Event
      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.INITIAL_FECTH }))
      },
      onInitFetch() {
        PatrimonioOwnerHttp.fetchOwnersByUserId(getUsuarioInfo().id)
          .then(owners =>
            setState(prevState => ({
              ...prevState,
              owners: owners,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },
      onNovoClick(selectedOwner) {
        if (selectedOwner)
          setState(prev => ({ ...prev, showModal: ATIVO_MODAL_NAME.CADASTRO, selectedAtivo: null }))
        else
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione um Dono para o Patrimonio',
          }))
      },
      onCadastroModalResponse(action, payload) {
        if (action === 'close') {
          setState(prev => ({ ...prev, showModal: ATIVO_MODAL_NAME.NONE, selectedAtivo: null }))
        } else if (action === 'success') {
          setState(prev => {
            const index = prev.ativos.findIndex(a => a.id === payload.id)
            if (index !== -1) {
              prev.ativos[index] = payload
            } else {
              prev.ativos.push(payload)
            }
            return {
              ...prev,
              ativos: [...prev.ativos],
              showModal: ATIVO_MODAL_NAME.NONE,
              selectedAtivo: null,
            }
          })
        } else if (action === 'error') {
          setState(prev => ({ ...prev, errorMessage: payload }))
        }
      },
      onLocalMovimentacaoModalResponse(action, payload) {
        if (action === 'close') {
          setState(prev => ({ ...prev, showModal: ATIVO_MODAL_NAME.NONE, selectedAtivo: null }))
        } else if (action === 'error') {
          setState(prev => ({ ...prev, errorMessage: payload }))
        }
      },
      onMenuItemClick(menuItem, ativo) {
        if (menuItem === 'Editar') {
          setState(prev => ({
            ...prev,
            showModal: ATIVO_MODAL_NAME.CADASTRO,
            selectedAtivo: ativo,
          }))
        }
      },
      onSelectedOwnerChange(value) {
        setState(prevState => ({
          ...prevState,
          selectedOwner: value,
          loadingMessage: LOAD_MESSAGE.FETCH_ATIVOS,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
